import { useContext, useMemo } from 'react';

import { GridWidgetsContext } from '../GridWidgetsContext';

export const useWidgetPositions = () => {
  const {
    dragInfo,
    widgetPositions = [],
    temporaryWidgetPositions = [],
  } = useContext(GridWidgetsContext);

  return useMemo(
    () =>
      dragInfo
        ? widgetPositions.map((widget) =>
            dragInfo.id !== widget.id
              ? temporaryWidgetPositions.find(({ id }) => id === widget.id)
              : widget
          )
        : widgetPositions,
    [dragInfo, widgetPositions, temporaryWidgetPositions]
  );
};
